"use strict";
/** *******************************************************************************************************************
  Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
  
  Licensed under the Apache License, Version 2.0 (the "License").
  You may not use this file except in compliance with the License.
  You may obtain a copy of the License at
  
      http://www.apache.org/licenses/LICENSE-2.0
  
  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.                                                                              *
 ******************************************************************************************************************** */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LabelList = exports.Label = exports.CartesianGrid = exports.YAxis = exports.XAxis = exports.Cell = exports.Brush = exports.Customized = exports.ReferenceDot = exports.ReferenceArea = exports.Legend = exports.Tooltip = exports.NORTHSTAR_COLORS = exports.Scatter = void 0;
const recharts_1 = require("recharts");
const withNorthStarBaseChart_1 = __importDefault(require("../withNorthStarBaseChart"));
const withNorthStarChart_1 = __importDefault(require("../withNorthStarChart"));
/**
 * Renders a Scatter Chart
 */
const ScatterChart = withNorthStarBaseChart_1.default(recharts_1.ScatterChart);
const Scatter = withNorthStarChart_1.default(recharts_1.Scatter);
exports.Scatter = Scatter;
exports.default = ScatterChart;
var themes_1 = require("../../themes");
Object.defineProperty(exports, "NORTHSTAR_COLORS", { enumerable: true, get: function () { return themes_1.NORTHSTAR_COLORS; } });
var recharts_2 = require("recharts");
Object.defineProperty(exports, "Tooltip", { enumerable: true, get: function () { return recharts_2.Tooltip; } });
Object.defineProperty(exports, "Legend", { enumerable: true, get: function () { return recharts_2.Legend; } });
Object.defineProperty(exports, "ReferenceArea", { enumerable: true, get: function () { return recharts_2.ReferenceArea; } });
Object.defineProperty(exports, "ReferenceDot", { enumerable: true, get: function () { return recharts_2.ReferenceDot; } });
Object.defineProperty(exports, "Customized", { enumerable: true, get: function () { return recharts_2.Customized; } });
Object.defineProperty(exports, "Brush", { enumerable: true, get: function () { return recharts_2.Brush; } });
Object.defineProperty(exports, "Cell", { enumerable: true, get: function () { return recharts_2.Cell; } });
Object.defineProperty(exports, "XAxis", { enumerable: true, get: function () { return recharts_2.XAxis; } });
Object.defineProperty(exports, "YAxis", { enumerable: true, get: function () { return recharts_2.YAxis; } });
Object.defineProperty(exports, "CartesianGrid", { enumerable: true, get: function () { return recharts_2.CartesianGrid; } });
Object.defineProperty(exports, "Label", { enumerable: true, get: function () { return recharts_2.Label; } });
Object.defineProperty(exports, "LabelList", { enumerable: true, get: function () { return recharts_2.LabelList; } });
//# sourceMappingURL=index.js.map